export default __webpack_public_path__ + "static/media/mark.0c50e391.png";